import { Pipe, PipeTransform } from '@angular/core';

export function decodeEscapedContent(value: string | null | undefined): string {
    const decodedUri = safeDecodeURI(value ?? '');

    try {
        return JSON.parse(`"${decodedUri.replace(/"/g, '\\"')}"`);
    } catch {
        return decodedUri;
    }
}

function safeDecodeURI(value: string): string {
    try {
        return decodeURI(value);
    } catch {
        return value;
    }
}

@Pipe({
    name: 'decodeURI',
    standalone: true,
})
export class DecodeURIPipe implements PipeTransform {
    transform(value: string | null | undefined, ...args: unknown[]): string {
        return decodeEscapedContent(value);
    }
}
